import axios from "axios";
import ENCOREMED_CONSTANTS from "../constants/encoremed";
import { em_server_api } from "../apiConfig";
import { getToken } from "../../localstorage";

/********** TODO LIST **********/

// patient
// create appointment
export const createAppointment = async (_data) => {
	try {
		let data = {};
		data.url = ENCOREMED_CONSTANTS.CREATE_APPOINTMENT;
		data.patient = {
			// id: 1, // TODO: temp hardcode, change when go live
			name: _data.name,
			// externalId: 1, // TODO: temp hardcode, change when go live
			identity: {
				type: "NATIONAL_ID",
				value: _data.nric,
			},
			callingCode: _data.callingCode,
			contactNo: _data.phoneNumber,
			email: _data.email,
			dob: _data.dob,
			nationality: _data.nationality,
			gender: _data.gender,
		};
		data.doctorId = _data.doctorId;
		data.startAt = _data.date;
		data.visitTypeId = _data.visitTypeId;
		data.extraFields = _data.extraFields;

		// return await callEncoremed("post", data, _data.tenantcode);
		return await callEncoremedViaServer("post", data, _data.tenantcode);
	} catch (error) {
		return {
			status: false,
			reason: error,
		};
	}
};

// list appointment based on ic
export const listAppointment = async (nric, tenantcode) => {
	try {
		let data = {};
		data.url = ENCOREMED_CONSTANTS.LIST_APPOINTMENT;
		data.identityNo = nric;
		data.limit = 100000;

		// return await callEncoremed("get", data, tenantcode);
		return await callEncoremedViaServer("get", data, tenantcode);
	} catch (error) {
		return {
			status: false,
			reason: error,
		};
	}
};

// view appointment info
export const viewAppointment = async (id, tenantcode) => {
	try {
		let data = {};
		data.url = ENCOREMED_CONSTANTS.VIEW_APPOINTMENT;
		data.appointmentId = id;

		// return await callEncoremed("get", data, tenantcode);
		return await callEncoremedViaServer("get", data, tenantcode);
	} catch (error) {
		return {
			status: false,
			reason: error,
		};
	}
};

// TODO: confirm appointment

// TODO: reschedule appointment

export const cancelAppoinment = async (appointment_id, tenantCode) => {
	try {
		let data = {};
		data.url = ENCOREMED_CONSTANTS.CANCEL_APPOINTMENT;
		data.appointmentId = appointment_id;

		// return await callEncoremed("post", data, tenantCode);
		return await callEncoremedViaServer("post", data, tenantCode);
	} catch (error) {
		return {
			status: false,
			reason: error,
		};
	}
};

// doctor
// get doctor info
export const getDoctor = async (doctorId, tenantcode) => {
	try {
		let data = {};
		data.url = ENCOREMED_CONSTANTS.VIEW_DOCTOR;
		data.doctorId = doctorId;

		// return await callEncoremed("get", data, tenantcode);
		return await callEncoremedViaServer("get", data, tenantcode);
	} catch (error) {
		return {
			status: false,
			reason: error,
		};
	}
};

// list doctor calendar slot
export const doctorCalendar = async (month, year, doctorId, tenantcode) => {
	// return {};
	try {
		let data = {};
		data.url = ENCOREMED_CONSTANTS.DOCTOR_CALENDAR;
		data.month = month;
		data.year = year;
		data.doctorId = doctorId;

		// return await callEncoremed("get", data, tenantcode);
		return await callEncoremedViaServer("get", data, tenantcode);
	} catch (error) {
		return {
			status: false,
			reason: error,
		};
	}
};

// list doctor timeslot
export const doctorTimeslot = async (date, doctorId, tenantcode) => {
	try {
		let data = {};
		data.url = ENCOREMED_CONSTANTS.DOCTOR_TIMESLOT;
		data.selectedDate = date;
		data.doctorId = doctorId;

		// const res = await callEncoremed("get", data, tenantcode);
		const res = await callEncoremedViaServer("get", data, tenantcode);
		return res;
	} catch (error) {
		return {
			status: false,
			reason: error,
		};
	}
};

/*******************************/

// to call encoremed API
const callEncoremed = async (method = "", data = null, tenantcode = "") => {
	if (!data) {
		return false;
	}
	// call API
	let response;
	const url = ENCOREMED_CONSTANTS.URL + tenantcode + "/v1" + data.url; // setup API url
	delete data.url; // remove url from data
	switch (method.toLowerCase()) {
		case "get":
			response = await axios.get(url, {
				headers: {
					"Content-Type": "application/json",
					Authorization: ENCOREMED_CONSTANTS.TOKEN,
				},
				params: data,
			});
			break;
		case "post":
			response = await axios.post(url, data, {
				headers: {
					"Content-Type": "application/json",
					Authorization: ENCOREMED_CONSTANTS.TOKEN,
				},
			});
			break;
	}
	if (response && response.status && response.data.statusCode === 200) {
		return {
			status: true,
			message: "Encoremed API called",
			data: response.data.result,
		};
	} else {
		return {
			status: false,
			reason: response.data?.data?.message,
			fullRes: response,
			data: data,
		};
	}
};

// to call encoremed API via server API (server to server)
const callEncoremedViaServer = async (
	method = "",
	data = null,
	tenantcode = ""
) => {
	if (!data) {
		return false;
	}
	// call API
	let response;
	const url = ENCOREMED_CONSTANTS.URL + tenantcode + "/v1" + data.url; // setup API url
	delete data.url; // remove url from data

	const apiData = {
		url,
		data,
		method,
	};

	// call server API
	response = await axios.post(em_server_api, apiData, {
		headers: {
			"X-API-KEY": "kpjhealth",
			Authorization: `Bearer ${getToken()}`,
		},
	});

	if (response && response.data.statusCode === 200) {
		return {
			status: true,
			message: "Encoremed API called",
			data: response.data.result,
		};
	} else {
		return {
			status: false,
			reason: response.data?.data?.message,
			fullRes: response,
			data: data,
		};
	}
};

// get date('c')
export const _getDate = () => {
	const now = new Date();

	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, "0");
	const day = String(now.getDate()).padStart(2, "0");

	const hours = String(now.getHours()).padStart(2, "0");
	const minutes = String(now.getMinutes()).padStart(2, "0");
	const seconds = String(now.getSeconds()).padStart(2, "0");

	const timezoneOffsetMinutes = now.getTimezoneOffset();
	const timezoneOffsetHours = Math.abs(Math.floor(timezoneOffsetMinutes / 60));
	const timezoneOffsetSign = timezoneOffsetMinutes > 0 ? "-" : "+";

	const timezoneOffset = `${timezoneOffsetSign}${String(
		timezoneOffsetHours
	).padStart(2, "0")}:${String(Math.abs(timezoneOffsetMinutes % 60)).padStart(
		2,
		"0"
	)}`;

	return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezoneOffset}`;
};

// convert 2022-10-28T17:30:00+00:00 to date and time
export const convertTZDate = (date, timezone = "8") => {
	const _date = new Date(date);
	// Set the desired timezone offset in minutes (GMT+8)
	const timeZoneOffset = timezone * -60;
	// Apply the timezone offset
	_date.setMinutes(_date.getMinutes() + timeZoneOffset);
	// Format the date and time with AM/PM
	const dateFormatOptions = { year: "numeric", month: "short", day: "numeric" };
	const timeFormatOptions = {
		hour: "numeric",
		minute: "numeric",
		second: "numeric",
		hour12: true,
	};
	const timeNoSecFormatOptions = {
		hour: "numeric",
		minute: "numeric",
		hour12: true,
	};
	const formattedDate = _date.toLocaleDateString("en-US", dateFormatOptions);
	const formattedTime = _date.toLocaleTimeString("en-US", timeFormatOptions);
	const formattedTimeNoSec = _date.toLocaleTimeString(
		"en-US",
		timeNoSecFormatOptions
	);

	// Create the object
	const dateTimeObject = {
		date: formattedDate,
		time: formattedTime,
		timeNoSec: formattedTimeNoSec,
	};

	return dateTimeObject;
};

export const convertBehTZDate = (date, timezone = "8") => {
	const _date = new Date(date);
	// Set the desired timezone offset in minutes (GMT+8)
	//const timeZoneOffset = timezone * (-60);
	//_date.setHours(_date.getHours() + 8);

	// Apply the timezone offset
	/* _date.setMinutes(_date.getMinutes() + timeZoneOffset);
  // Format the date and time with AM/PM
  const dateFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
  const timeFormatOptions = { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
  const timeNoSecFormatOptions = { hour: 'numeric', minute: 'numeric', hour12: true };

  const formattedDate = _date.toLocaleDateString('en-US', dateFormatOptions);
  const formattedTime = _date.toLocaleTimeString('en-US', timeFormatOptions);
  const formattedTimeNoSec = _date.toLocaleTimeString('en-US', timeNoSecFormatOptions); */
	const formattedDate = _date.toLocaleDateString("en-US"); // Adjust format as needed
	const formattedTime = _date.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "numeric",
		second: "numeric",
		hour12: true,
	}); // Adjust format as needed

	// Create the object
	const dateTimeObject = {
		date: formattedDate,
		time: formattedTime,
	};
	return dateTimeObject;
};

// convert date and time to 2022-10-28T17:30:00+08:00
export const generateTZDate = (dateString, timeString, timezone = "8") => {
	// Combine the date and time strings
	const combinedDateTimeString = `${dateString}T${timeString}:00`;

	// Create a Date object with the combined date and time string
	const date = new Date(combinedDateTimeString);

	// Calculate the timezone offset in milliseconds
	const timeZoneOffsetMs = timezone * 60 * 60 * 1000;

	// Adjust the date and time to the desired timezone
	const timestampInTimeZone = new Date(date.getTime() + timeZoneOffsetMs);

	// Convert to ISO 8601 format with timezone offset
	const isoTimestamp = timestampInTimeZone.toISOString();

	return isoTimestamp;
};
